// Polyfills and custom DOM extensions

const extensions = {}
const context = require.context("polyfills", true, /\.js$/)
context.keys().forEach(filename => {
  context(filename)
})
